import React from 'react';
import styles from './ResizingIframe.css';

// const debounce = (fn, period) => {
//   let handle;
//
//   return (...args) => {
//     clearTimeout(handle);
//     handle = setTimeout(() => fn(...args), period);
//   }
// };

class ResizingIframe extends React.Component {
  handleIframeMutation = () => {
    this.iframe.style.height =
      this.iframe.contentWindow.document.documentElement.offsetHeight + 'px';

    this.setState({
      loading: false,
    });

    if (typeof this.props.onLoad === 'function') {
      this.props.onLoad();
    }
  };

  setIframeContent = html => {
    const iframeWindow = this.iframe.contentWindow;

    // const observer = new MutationObserver(debounce(this.handleIframeMutation, 1000));
    const observer = new MutationObserver(this.handleIframeMutation);

    observer.observe(iframeWindow, {
      childList: true,
      attributes: true,
      characterData: true,
      subtree: true,
      attributeOldValue: true,
      characterDataOldValue: true,
      attributeFilter: [],
    });

    iframeWindow.write(html);
    iframeWindow.close();
  };

  legacySrc = () => {
    this.iframe.onload = () => {
      this.setState({
        loading: false,
      });

      if (typeof this.props.onLoad === 'function') {
        this.props.onLoad();
      }
    };

    this.iframe.src = this.props.src;
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  fetchSrc() {
    if (typeof fetch === 'function') {
      this.setState({
        loading: true,
      });

      fetch(this.props.src)
        .then(response => response.text())
        .then(html => {
          if (this.iframe) {
            this.setIframeContent(html);
          }
        })
        .catch(() => {
          if (this.iframe) {
            this.legacySrc();
          }
        });
    } else {
      this.legacySrc();
    }
  }

  componentDidMount() {
    this.fetchSrc();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src) {
      this.fetchSrc();
    }
  }

  render() {
    return (
      <iframe
        style={{ visibility: this.state.loading ? 'hidden' : 'visible' }}
        title={this.props.title}
        className={styles.iframe}
        frameBorder={0}
        ref={ref => (this.iframe = ref)}
      />
    );
  }
}

export default ResizingIframe;



// WEBPACK FOOTER //
// ./src/general-components/ResizingIframe.js